import React, { useState } from "react";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from "@react-navigation/native";

export const useLocalStorage = () => {
    const [value, setValue] = useState<string | null>(null);
    const navigation = useNavigation();

    const setItem = async (key: string, value: string, callback: () => void) => {
      try {
        await AsyncStorage.setItem(key, value);
        setValue(value);
        callback();  // Call the callback function after setting the item
      } catch (error) {
        console.error('Error setting item:', error);
      }
    };

  const getItem = async (key: string) => {
    const value = await AsyncStorage.getItem(key);
    setValue(value);
    return value;
  };

  const removeItem = async (key: string) => {
    await AsyncStorage.removeItem(key);
    setValue(null);
  };

  return { value, setItem, getItem, removeItem };
};
